module.exports = __webpack_public_path__ + "static/media/ship.04c196bb.svg";